import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Virtuoso } from 'react-virtuoso';

// @ts-ignore
import { chatModule, communicationModule } from '@chedri/base';

import Spinner from 'components/Spinner';
import ContactItem from './ContactItem';

function CommunicationContacts({ onItemSelected }) {
  const items = useSelector(communicationModule.contact.selectors.getList);

  const isLoading = useSelector(communicationModule.contact.selectors.isListLoading);

  const activeConversations = useSelector(chatModule.selectors.getActiveConversations);

  const unopenedMessagesFrom = useSelector(chatModule.selectors.getUnopenedMessagesFrom);

  const conversationsMap = useMemo(() => {
    if (!Array.isArray(activeConversations)) {
      return new Map();
    }

    return new Map(activeConversations.map((conversation) => [conversation.username, conversation]));
  }, [activeConversations]);

  if (isLoading || !items) {
    return <Spinner className="text-success" size={24} />;
  }

  if (!Array.isArray(items) || items.length === 0) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        No contacts available / or not yet loaded
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        minHeight: 0,
      }}
    >
      <Virtuoso
        data={items}
        style={{
          width: '100%',
          height: '100%',
        }}
        className="ReactVirtualized__Grid ReactVirtualized__List"
        computeItemKey={(index, item) => item.id}
        itemContent={(index, item) => {
          let lastMessage = item.last_message;

          const conversation = conversationsMap.get(item.id);

          let unopenedMessagesCount = item.unseen_messages || 0;

          if (unopenedMessagesFrom[item.id]) {
            unopenedMessagesCount = unopenedMessagesFrom[item.id].messages;
          }

          if (conversation && Array.isArray(conversation.messages) && conversation.messages.length > 0) {
            lastMessage = conversation.messages[0].message;
          }

          return (
            <ContactItem
              item={item}
              lastMessage={lastMessage}
              unopenedMessagesCount={unopenedMessagesCount}
              onClick={onItemSelected}
            />
          );
        }}
      />
    </div>
  );
}


export default CommunicationContacts;
